<template>
    <div class="products-shell">
        <FilterManager ref="filterManager" :config="config" @resetPage="resetPage" @refresh="refresh" />

        <div class="pf-main">
            <!-- Top toolbar -->
            <div class="pf-toolbar">
                <span class="pf-count">
                    <template v-if="metadata && metadata.total">{{ metadata.total }} producto{{ metadata.total === 1 ? '' : 's' }}</template>
                    <template v-else>Catálogo de productos</template>
                </span>
                <div class="pf-pagination" v-if="pages > 1">
                    <button class="pf-page-btn" @click.prevent="changePage(pageFilter - 1)" :disabled="pageFilter < 1" aria-label="Anterior">‹</button>
                    <button v-for="(page, index) in visiblePages" :key="'t' + index" class="pf-page-btn"
                        :class="{ 'is-active': (pageFilter + 1) === page }" @click.prevent="changePage(page - 1)">
                        {{ page }}
                    </button>
                    <button class="pf-page-btn" @click.prevent="changePage(pageFilter + 1)" :disabled="pageFilter >= (pages - 1)" aria-label="Siguiente">›</button>
                </div>
            </div>

            <!-- Grid -->
            <div class="pf-grid" v-if="!status.get && products && products.length > 0">
                <a v-for="(product, index) in products" :key="index" class="pf-card" :href="`/productos/${product.slug}`">
                    <div class="pf-card-img">
                        <img v-if="product.asset && product.asset.slug"
                            :src="`https://lubricantesrino-208fe.kxcdn.com/api/public/v1/assets/${product.asset.slug}`"
                            :alt="product.name" loading="lazy">
                    </div>
                    <div class="pf-card-body">
                        <h3 class="pf-card-title">{{ product.name }}</h3>
                        <p class="pf-card-desc">{{ product.short_description }}</p>
                        <span class="pf-card-link">VER DETALLE
                            <svg width="12" height="12" viewBox="0 0 14 14" fill="none"><path d="M2 7 H 12 M 8 3 L 12 7 L 8 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </span>
                    </div>
                </a>
            </div>

            <!-- Loading skeletons -->
            <div class="pf-grid" v-else-if="status.get" role="status">
                <div class="pf-skel" v-for="i in 9" :key="i"></div>
            </div>

            <!-- Empty -->
            <div class="pf-empty" v-else>
                <i class="far fa-frown icon-sad"></i><br>
                No se han encontrado productos
            </div>

            <!-- Bottom toolbar -->
            <div class="pf-toolbar" style="border-top: 1px solid var(--hairline); border-bottom: 0; padding-top: 16px; padding-bottom: 0;"
                v-if="!status.get && pages > 1">
                <span class="pf-count">PÁG {{ pageFilter + 1 }} DE {{ pages }}</span>
                <div class="pf-pagination">
                    <button class="pf-page-btn" @click.prevent="changePage(pageFilter - 1)" :disabled="pageFilter < 1" aria-label="Anterior">‹</button>
                    <button v-for="(page, index) in visiblePages" :key="'b' + index" class="pf-page-btn"
                        :class="{ 'is-active': (pageFilter + 1) === page }" @click.prevent="changePage(page - 1)">
                        {{ page }}
                    </button>
                    <button class="pf-page-btn" @click.prevent="changePage(pageFilter + 1)" :disabled="pageFilter >= (pages - 1)" aria-label="Siguiente">›</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Moment from 'moment';
import FilterManager from './components/FilterManager.vue';
import { useAwn } from '/composables/useAwn';

export default {
    components: {
        FilterManager
    },
    data() {
        return {
            products: null,
            metadata: null,
            status: {
                get: true
            },
            config: {
                colors: null,
                categories: null,
                brands: null
            },
            pageFilter: 0,
            awn: null
        }
    },
    mounted() {
        this.awn = useAwn()
        this.getConfigVariables();
    },
    computed: {
        pages: function () {
            return this.metadata && this.$refs.filterManager ? Math.ceil(this.metadata.total / this.$refs.filterManager.filters.page_size) : 0;
        },
        visiblePages: function () {
            const total = this.pages;
            const current = this.pageFilter + 1;
            if (total <= 7) {
                return Array.from({ length: total }, (_, i) => i + 1);
            }
            let start = Math.max(1, current - 2);
            let end = Math.min(total, start + 4);
            start = Math.max(1, end - 4);
            const result = [];
            for (let i = start; i <= end; i++) result.push(i);
            return result;
        }
    },
    watch: {
        pageFilter: {
            handler: function (newItem) {
                if (this.metadata) {
                    this.$refs.filterManager.refresh();
                }
            },
            immediate: true
        }
    },
    methods: {
        refresh(filters) {
            this.status.get = true;

            let searchFilter = !!filters.search_filter ? `&search_filter=${filters.search_filter}` : '';
            let categoriesFilter = filters.categories ? `&categories=${filters.categories}` : '';
            let isosFilter = !!filters.isos ? `&isos=${filters.isos}` : '';
            let basesFilter = !!filters.bases ? `&bases=${filters.bases}` : '';
            let brandFilter = !!filters.brand ? `&brand=${filters.brand}` : '';

            let params = searchFilter + brandFilter + categoriesFilter + isosFilter + basesFilter;

            axios.get(`/api/public/v1/products?pageSize=${filters.page_size}&page=${this.pageFilter + 1}${params}`, {
                headers: {
                    "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
                }
            }).then(response => {
                this.products = response.data.data;
                this.metadata = response.data.meta;
            }).catch((e) => {
                this.awn.warning('No se han podido obtener los productos');
            }).finally(() => {
                this.status.get = false;
            });
        },
        getConfigVariables() {
            axios.get(`/api/public/v1/products/support-data`, {
                headers: {
                    "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
                }
            }).then(response => {
                this.config.isos = response.data.data.isos;
                this.config.bases = response.data.data.bases;
                this.config.colors = response.data.data.colors;
                this.config.categories = response.data.data.categories;
            });


            axios.get(`/api/public/v1/brands?pageSize=100`, {
                headers: {
                    "x-api-key": "NPP3dB1ch8CiEmRGprtB2Vpr7xbZdA7iUnw7gX7ORjXdX0vzQ"
                }
            }).then(response => {
                this.config.brands = response.data.data;
            });
        },
        formatDate(date) {
            return Moment.utc(date).format('DD/MM/YYYY');
        },
        changePage(number) {
            if (number >= 0 && number < this.pages) {
                this.pageFilter = number;
            }
        },
        setPage(page) {
            switch (page) {
                case 1:
                    //this.buttonActivated = page; son 4 paginas
                    return this.pageFilter + 1;
                case 2:
                    //this.buttonActivated = page;
                    return this.pageFilter + 2;
                case 3:
                    //this.buttonActivated = page;
                    return this.pageFilter + 3;
                default:
                    return 0;
            }
        },
        resetPage() {
            this.pageFilter = 0;
        },
        maxPrice(presentations, default_price) {
            return presentations.reduce((acc, obj) => obj.price > acc ? obj.price : acc, default_price);
        },
        minPrice(presentations, default_price) {
            return presentations.reduce((acc, obj) => obj.price < acc ? obj.price : acc, default_price);
        }
    }
}
</script>
<style lang="scss" scoped>
.green {
    color: green;
}

.red {
    color: red;
}

.spinner-margin {
    width: 5rem;
    height: 5rem;
}

.h-977 {
    min-height: 704px;
}

.text-align-last-center {
    text-align-last: center;
}

.icon-sad {
    font-size: 150px;
}

.text-left-line {
    border-left: solid grey 1px;
}

.active {
    color: #ffffff !important;
    background-color: #007bff !important;
    border-color: #007bff !important;
}
</style>